import styled from '@emotion/styled';
import { RiArrowRightUpLine } from 'react-icons/ri';
import PropTypes from 'prop-types';

const Container = styled.a`
  height: max-content;
  width: max-content;
  color: inherit;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  position: relative;
  transition: color 0.3s ease;

  span {
    position: relative;
  }

  span:after {
    content: '';
    height: 1px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: currentcolor;
    transform: scaleX(1);
    transform-origin: right;
    transition: transform 0.3s ease;
  }

  svg {
    font-size: 1.5em;
    color: inherit;
    transition: transform 0.3s ease;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    &:hover {
      color: ${({ theme }) => theme.colors.accent};

      span:after {
        transform: scaleX(0);
      }

      svg {
        transform: translateY(-0.4rem);
      }
    }
  }
`;

const StyledLink = ({ label, url }) => {
  return (
    <Container href={url} target="_blank" rel="noopener noreferrer">
      <span>{label}</span>
      <RiArrowRightUpLine aria-hidden="true" />
    </Container>
  );
};

StyledLink.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
export default StyledLink;
